module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f6a8.b56e4108.svg";